export const SET_LOCATION = "SET_LOCATION";
export const SET_NAME = "SET_NAME";
export const SET_VIEWPORT = "SET_VIEWPORT";
export const SET_ADDRESS = "SET_ADDRESS";
export const SET_COORDS = "SET_COORDS";
export const GET_FIRES_START = "GET_FIRES_START";
export const GET_FIRES_SUCCESS = "GET_FIRES_SUCCESS";
export const GET_FIRES_ERROR = "GET_FIRES_ERROR";
export const SET_FIRE_DATA = "SET_FIRE_DATA";
export const SET_COORDINATES = "SET_COORDINATES";
export const SET_TRIGGER = "SET_TRIGGER";
export const GET_LOCATIONS = "GET_LOCATIONS";
export const GET_FIREDATA = "GET_COORDS";
export const SET_SHOW_ALERT = "SET_SHOW_ALERT";
export const SET_ALERT_VIEWED = "SET_ALERT_VIEWED";
